import Swal from 'sweetalert2'

let authRecoveryInProgress = false

/** ตัดการเชื่อมต่อ WebSocket เพื่อให้ gateway แจ้ง user_offline ทันที (admin เห็น offline ไม่ค้าง) */
function disconnectWebSocketNow(): void {
  if (typeof window === 'undefined') return
  try {
    const win = window as unknown as { __huayWebSocket?: { disconnect?: () => void; removeAllListeners?: () => void; close?: () => void } | null }
    if (win.__huayWebSocket) {
      win.__huayWebSocket.removeAllListeners?.()
      win.__huayWebSocket.disconnect?.()
      win.__huayWebSocket.close?.()
      win.__huayWebSocket = null
    }
  } catch {
    /* ignore */
  }
}

/**
 * เมื่อ backend ส่ง 401 + code SESSION_REPLACED (มีการล็อกอินจากที่อื่น)
 * แสดง SweetAlert นับถอยหลัง 5 วินาที (ห้ามกดปิด) จากนั้นล้าง auth และ reload
 */
export async function handleSessionReplaced(): Promise<void> {
  if (authRecoveryInProgress) return
  authRecoveryInProgress = true
  let countDown = 5
  await Swal.fire({
    icon: 'warning',
    title: 'มีการเข้าสู่ระบบจากที่อื่น',
    html: `
      <p class="mb-2">บัญชีนี้ได้เข้าสู่ระบบจากอุปกรณ์หรือแท็บอื่นแล้ว</p>
      <p class="mb-0">บัญชีนี้จะถูกออกจากระบบใน <strong id="session-replaced-countdown">${countDown}</strong> วินาที</p>
    `,
    showConfirmButton: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    timer: 5000,
    timerProgressBar: true,
    didOpen: () => {
      const el = document.getElementById('session-replaced-countdown')
      if (!el) return
      const iv = setInterval(() => {
        countDown -= 1
        el.textContent = String(Math.max(0, countDown))
        if (countDown <= 0) clearInterval(iv)
      }, 1000)
    },
  })

  disconnectWebSocketNow()

  localStorage.removeItem('accessToken')
  localStorage.removeItem('refreshToken')
  localStorage.removeItem('user')
  localStorage.removeItem('deviceId')
  localStorage.removeItem('tenantId')
  localStorage.removeItem('rememberMe')
  sessionStorage.removeItem('concurrentLoginDetected')
  if (typeof window !== 'undefined') {
    window.location.hash = '#/'
    window.location.reload()
  }
}

export async function handleAuthExpired(): Promise<void> {
  if (authRecoveryInProgress) return
  authRecoveryInProgress = true

  disconnectWebSocketNow()

  localStorage.removeItem('accessToken')
  localStorage.removeItem('refreshToken')
  localStorage.removeItem('user')
  localStorage.removeItem('deviceId')
  localStorage.removeItem('tenantId')
  localStorage.removeItem('rememberMe')
  sessionStorage.removeItem('concurrentLoginDetected')

  await Swal.fire({
    icon: 'warning',
    title: 'เซสชันหมดอายุ',
    text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง',
    confirmButtonText: 'ตกลง',
    allowOutsideClick: false,
    allowEscapeKey: false,
  })

  if (typeof window !== 'undefined') {
    window.location.href = '/login'
  }
}
